import { ClientId, Options } from '@chegg/one-auth';
import { CheggTlds } from '@chegg/utils';

export enum ViewQueryParam {
  SIGNIN = 'login',
  SIGNUP = 'signup',
  FORGOT_PASSWORD = 'forgotpassword',
}

export enum UniqueCheggProfile {
  SIMPLIFIED_STUDY = 'simplifiedstudy',
  PLA = 'pla',
  CHEGG_MATH_PRICING = 'cheggmathpricing',
  RM = 'rm',
  UV = 'uversity',
}

export const profileIdentifiers: Record<string, ClientId> = {
  CHGG: 'CHGG',
  BM: 'BM',
  CM: 'CM',
  EB: 'EB',
  CTFM: 'CTFM',
  IDC: 'IDC',
  CJP: 'CJP',
  FLASHTOOLS: 'FLASHTOOLS',
  FT_IOS: 'FT_IOS',
  FT_DROID: 'FT_DROID',
  CW: 'CW',
  CS_STREAMLINE: 'CHGG',
  MATH: 'CHGG',
  RM: 'CHGG',
};

export const defaultOptions: Options = {
  signin: {
    ssoProviders: ['apple', 'facebook', 'google'],
  },
  signup: {
    form: {
      credentials: {
        ssoProviders: ['apple', 'facebook', 'google'],
      },
      userInfo: {
        student: {
          highschool: {
            highschoolGradYearSelect: true,
          },
          college: {
            collegeSelect: {
              yearInSchool: true,
            },
          },
        },
        parent: {},
      },
    },
  },
};

export const simplifiedSignup = {
  credentials: {
    ssoProviders: ['apple', 'facebook', 'google'],
  },
};

export const allowedRedirectDomains = [
  '.chegg.com',
  '.chegg.com.mx',
  '.cheggnet.com',
  '.cheggnet.com.mx',
  '.careermatch.com',
  '.internships.com',
  '.easybib.com',
  '.citationmachine.net',
  '.citethisforme.com',
  '.bibme.org',
  '.mathway.com',
];

export const DEFAULT_LANGUAGE_LOCALE = {
  [CheggTlds.MX]: 'es-419',
  [CheggTlds.default]: 'en',
} as const;
